
const ADDED_TO_BOB_MODAL = 'ADDED_TO_BOB_MODAL';
const BECOME_AOR_MODAL = 'BECOME_AOR_MODAL';
const FALLBACK_UI_MODAL = 'FALLBACK_UI_MODAL';
const LOCATE_ASSISTANCE_MODAL = 'LOCATE_ASSISTANCE_MODAL';
const SAVE_RESULT_MODAL = 'SAVE_RESULT_MODAL';
const SESSION_IDLE_WARNING_MODAL = 'SESSION_IDLE_WARNING_MODAL';
const APP_IN_PROGRESS = 'APP_IN_PROGRESS';
const REQUEST_ERROR = 'REQUEST_ERROR';
const RESUBMIT_MODAL = 'RESUBMIT_MODAL';
const SEARCH_RESULT_MODAL = 'SEARCH_RESULT_MODAL';
const UPLOAD_MODAL = 'UPLOAD_MODAL';
const VIEW_IMAGE_MODAL = 'VIEW_IMAGE_MODAL';
const SELF_DESIGNATION_OTP_MODAL = 'SELF_DESIGNATION_OTP_MODAL';
const SELF_DESIGNATION_OTP_ERROR_MODAL = 'SELF_DESIGNATION_OTP_ERROR_MODAL';
const ADMIN_PLANS_DRUGS_COMMON_MODAL = 'ADMIN_PLANS_DRUGS_COMMON_MODAL';



export const commonModalTypes = {
    ADDED_TO_BOB_MODAL,
    BECOME_AOR_MODAL,
    FALLBACK_UI_MODAL,
    LOCATE_ASSISTANCE_MODAL,
    SAVE_RESULT_MODAL,
    SESSION_IDLE_WARNING_MODAL,
    APP_IN_PROGRESS,
    REQUEST_ERROR,
    RESUBMIT_MODAL,
    SEARCH_RESULT_MODAL,
    UPLOAD_MODAL,
    VIEW_IMAGE_MODAL,
    SELF_DESIGNATION_OTP_MODAL,
    SELF_DESIGNATION_OTP_ERROR_MODAL,
    ADMIN_PLANS_DRUGS_COMMON_MODAL
};